<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
// import { Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import { Header as AppHeader, Sidebar, Footer as AppFooter, Breadcrumb } from '../components/'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    ...mapGetters([
      'GET_AUTH'
    ]),
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  mounted () {
    if (!this.GET_AUTH) {
      this.$router.push({path: '/login'})
    } else {
      axios.defaults.headers.common['X-API-TOKEN'] = this.GET_AUTH
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue